export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14472.1ccc04e1.jpg";